package com.mxpainting

import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember

enum class Language {
    ENGLISH,
    SPANISH
}

private const val SAVE_KEY = "mxpainting_lang"

object LanguageState {
    val current: MutableState<Language> by lazy {
        val saved = kotlinx.browser.window.localStorage.getItem(SAVE_KEY)
        val initialLanguage = Language.entries.find { it.name == saved } ?: Language.ENGLISH
        mutableStateOf(initialLanguage)
    }

    fun setLanguage(language: Language) {
        current.value = language
        kotlinx.browser.window.localStorage.setItem(SAVE_KEY, language.name)
    }
}

@Composable
fun rememberLanguage(): MutableState<Language> {
    return remember { LanguageState.current }
}
